export const isIos = () =>
  /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ||
  // для iPad'ов на iOS 13
  (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

export const makeFakeInputForIos = () => {
  // Зачем?
  // https://gist.github.com/cathyxz/73739c1bdea7d7011abb236541dc9aaa
  // https://stackoverflow.com/a/55652503
  const fakeInput = document.createElement('input');
  fakeInput.setAttribute('type', 'text');
  fakeInput.style.position = 'absolute';
  fakeInput.style.opacity = 0;
  fakeInput.style.height = 0;
  fakeInput.style.fontSize = '16px'; // disable auto zoom
  document.body.prepend(fakeInput);
  fakeInput.focus();

  return fakeInput;
};

export const geoControlFocusMobileInput = (mobileInput, inputToBlur, selector = '.MobileSearchHeader') => {
  const displayValue = window.getComputedStyle(mobileInput.closest(selector)).display;
  const focusOnMobileInput = ['block', 'flex'].includes(displayValue);

  if (focusOnMobileInput) {
    if (isIos()) {
      const fakeInput = makeFakeInputForIos(mobileInput);

      setTimeout(() => {
        mobileInput.focus();
        fakeInput.remove();
      }, 500);
    } else {
      inputToBlur?.blur();
      setTimeout(() => mobileInput.focus(), 500);
    }
  }
};
